const methodData =
[
    {
        "name": "average()",
        "description": "Calcula y devuelve el valor promedio de todos los elementos contenidos en el array",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.horasProyectos: [45, 32, 28]\n{{ $json.horasProyectos.average() }}\n// Output: 35",
        "datatype": "Array"
    },
    {
        "name": "chunk(size*)",
        "description": "Divide el array en fragmentos más pequeños, cada uno con el tamaño especificado",
        "parameters": [
            {
                "description": "El tamaño de cada fragmento.",
                "type": "Number",
                "required": true,
                "name": "size"
            }
        ],
        "return_type": "Number",
        "example": "// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]\n{{ $json.serviciosInteresados.chunk(2) }}\n// Output: [[\"automatización de procesos\", \"CRM\"], [\"WhatsApp\"]]",
        "datatype": "Array"
    },
    {
        "name": "compact()",
        "description": "Elimina todos los valores vacíos o nulos del array, devolviendo una versión limpia",
        "parameters": [],
        "return_type": "Array",
        "example": "// $json.data.estadosImplementacion: [true, false, null, true, 0, '']\n{{ $json.estadosImplementacion.compact() }}\n// Output: [true, false, true]",
        "datatype": "Array"
    },
    {
        "name": "difference(arr*)",
        "description": "Compara dos arrays y devuelve los elementos que están en el array base pero no en el array de comparación",
        "parameters": [
            {
                "description": "El array con el que se va a comparar el array base.",
                "type": "Array",
                "required": true,
                "name": "arr"
            }
        ],
        "return_type": "Array",
        "example": "// $json.data.serviciosDisponibles: [\"CRM\", \"WhatsApp\", \"ERP\", \"Business Intelligence\", \"automatización de procesos\"]\n// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]\n{{ $json.serviciosDisponibles.difference($json.serviciosInteresados) }}\n// Output: [\"ERP\", \"Business Intelligence\"]",
        "datatype": "Array"
    },
    {
        "name": "intersection(arr*)",
        "description": "Encuentra y devuelve los elementos comunes que existen en ambos arrays",
        "parameters": [
            {
                "description": "El array con el que se va a comparar el array base.",
                "type": "Array",
                "required": true,
                "name": "arr"
            }
        ],
        "return_type": "Array",
        "example": "// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]\n// $json.data.serviciosDisponibles: [\"CRM\", \"WhatsApp\", \"ERP\", \"Business Intelligence\", \"automatización de procesos\"]\n{{ $json.serviciosInteresados.intersection($json.serviciosDisponibles) }}\n// Output: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]",
        "datatype": "Array"
    },
    {
        "name": "first()",
        "description": "Obtiene y devuelve el primer elemento del array",
        "parameters": [],
        "return_type": "Item",
        "example": "// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]\n{{ $json.serviciosInteresados.first() }}\n// Output: \"automatización de procesos\"",
        "datatype": "Array"
    },
    {
        "name": "isEmpty()",
        "description": "Verifica si el array está vacío, sin ningún elemento",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.implementacionesPrevias: []\n{{ $json.implementacionesPrevias.isEmpty() }}\n// Output: true",
        "datatype": "Array"
    },
    {
        "name": "isNotEmpty()",
        "description": "Verifica si el array contiene al menos un elemento",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.horasProyectos: [45, 32, 28]\n{{ $json.horasProyectos.isNotEmpty() }}\n// Output: true",
        "datatype": "Array"
    },
    {
        "name": "last()",
        "description": "Obtiene y devuelve el último elemento del array",
        "parameters": [],
        "return_type": "Item",
        "example": "// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]\n{{ $json.serviciosInteresados.last() }}\n// Output: \"WhatsApp\"",
        "datatype": "Array"
    },
    {
        "name": "max()",
        "description": "Encuentra y devuelve el valor numérico más alto dentro del array",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.horasProyectos: [45, 32, 28]\n{{ $json.horasProyectos.max() }}\n// Output: 45",
        "datatype": "Array"
    },
    {
        "name": "merge(arr*)",
        "description": "Combina dos arrays de objetos en uno solo, fusionando las propiedades clave-valor de cada elemento",
        "parameters": [
            {
                "description": "El array que se va a fusionar con el array base.",
                "type": "Array",
                "required": true,
                "name": "arr"
            }
        ],
        "return_type": "Array",
        "example": "// $json.data.reuniones: [{\"id\": \"REU001\", \"tipo\": \"exploratoria\"}]\n// $json.data.nuevasReuniones: [{\"id\": \"REU001\", \"fecha\": \"2025-05-10\"}]\n{{ $json.reuniones.merge($json.nuevasReuniones) }}\n// Output: [{\"id\": \"REU001\", \"tipo\": \"exploratoria\", \"fecha\": \"2025-05-10\"}]",
        "datatype": "Array"
    },
    {
        "name": "min()",
        "description": "Encuentra y devuelve el valor numérico más bajo de un array que contenga solo números",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.horasProyectos: [45, 32, 28]\n{{ $json.horasProyectos.min() }}\n// Output: 28",
        "datatype": "Array"
    },
    {
        "name": "pluck(fieldName?)",
        "description": "Extrae y devuelve un array de objetos que contienen únicamente las claves especificadas",
        "parameters": [
            {
                "description": "La(s) clave(s) que deseas extraer. Puedes introducir múltiples claves separadas por comas.",
                "type": "String",
                "required": false,
                "name": "fieldName"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.contactosInternos: [{\"nombre\": \"Laura Pérez\", \"rol\": \"COO\"}, {\"nombre\": \"Sergio Gómez\", \"rol\": \"Responsable de IT\"}]\n{{ $json.contactosInternos.pluck('nombre') }}\n// Output: [\"Laura Pérez\", \"Sergio Gómez\", \"Clara Ortega\"]",
        "datatype": "Array"
    },
    {
        "name": "randomItem()",
        "description": "Selecciona y devuelve un elemento aleatorio del array",
        "parameters": [],
        "return_type": "Item",
        "example": "// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]\n{{ $json.serviciosInteresados.randomItem() }}\n// Output: \"CRM\" (aleatorio)",
        "datatype": "Array"
    },
    {
        "name": "removeDuplicates(key?)",
        "description": "Elimina elementos duplicados del array, manteniendo solo las entradas únicas",
        "parameters": [
            {
                "description": "Una clave o lista de claves separadas por comas para verificar duplicados.",
                "type": "String",
                "required": false,
                "name": "key"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.serviciosDuplicados: [\"CRM\", \"WhatsApp\", \"CRM\", \"ERP\"]\n{{ $json.serviciosDuplicados.removeDuplicates() }}\n// Output: [\"CRM\", \"WhatsApp\", \"ERP\"]",
        "datatype": "Array"
    },
    {
        "name": "renameKeys(from*,to*)",
        "description": "Cambia el nombre de todas las claves coincidentes en el array. Puedes renombrar múltiples claves introduciendo series de cadenas separadas por comas con el patrón nombreAntiguo, nombreNuevo",
        "parameters": [
            {
                "description": "La clave que deseas renombrar.",
                "type": "String",
                "required": true,
                "name": "from"
            },
            {
                "description": "El nuevo nombre.",
                "type": "String",
                "required": true,
                "name": "to"
            }
        ],
        "return_type": "Stringto",
        "example": "// $json.data.contactosInternos: [{\"nombre\": \"Laura Pérez\", \"rol\": \"COO\"}]\n{{ $json.contactosInternos.renameKeys('nombre', 'name') }}\n// Output: [{\"name\": \"Laura Pérez\", \"rol\": \"COO\"}]",
        "datatype": "Array"
    },
    {
        "name": "smartJoin(keyField*,nameField*)",
        "description": "Opera sobre un array de objetos con pares clave-valor. Crea un nuevo objeto donde la clave es el valor del primer par y el valor es el valor del segundo par. Elimina valores no coincidentes y vacíos, y recorta espacios en blanco antes de unir",
        "parameters": [
            {
                "description": "La clave que se va a unir.",
                "type": "String",
                "required": true,
                "name": "keyField"
            },
            {
                "description": "El valor que se va a unir.",
                "type": "String",
                "required": true,
                "name": "nameField"
            }
        ],
        "return_type": "StringnameField",
        "example": "// $json.data.contactosInternos: [{\"nombre\": \"Laura Pérez\", \"rol\": \"COO\"}, {\"nombre\": \"Sergio Gómez\", \"rol\": \"Responsable de IT\"}]\n{{ $json.contactosInternos.smartJoin('nombre', 'rol') }}\n// Output: {\"Laura Pérez\": \"COO\", \"Sergio Gómez\": \"Responsable de IT\"}",
        "datatype": "Array"
    },
    {
        "name": "sum()",
        "description": "Calcula y devuelve la suma total de todos los valores numéricos parseables del array",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.horasProyectos: [45, 32, 28]\n{{ $json.horasProyectos.sum() }}\n// Output: 105",
        "datatype": "Array"
    },
    {
        "name": "toJsonString()",
        "description": "Convierte el array en una cadena de texto JSON. Equivale a JSON.stringify",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\", \"WhatsApp\"]\n{{ $json.serviciosInteresados.toJsonString() }}\n// Output: \"[\\\"automatización de procesos\\\",\\\"CRM\\\",\\\"WhatsApp\\\"]\"",
        "datatype": "Array"
    },
    {
        "name": "union(arr*)",
        "description": "Une dos arrays en uno solo y después elimina los elementos duplicados",
        "parameters": [
            {
                "description": "El array que se va a comparar con el array base.",
                "type": "Array",
                "required": true,
                "name": "arr"
            }
        ],
        "return_type": "Array",
        "example": "// $json.data.serviciosInteresados: [\"automatización de procesos\", \"CRM\"]\n// $json.data.serviciosAdicionales: [\"CRM\", \"ERP\", \"Business Intelligence\"]\n{{ $json.serviciosInteresados.union($json.serviciosAdicionales) }}\n// Output: [\"automatización de procesos\", \"CRM\", \"ERP\", \"Business Intelligence\"]",
        "datatype": "Array"
    },
    {
        "name": "unique(key?)",
        "description": "Elimina elementos duplicados del array, conservando solo valores únicos",
        "parameters": [
            {
                "description": "Una clave o lista de claves separadas por comas para verificar duplicados.",
                "type": "String",
                "required": false,
                "name": "key"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.serviciosDuplicados: [\"CRM\", \"WhatsApp\", \"CRM\", \"ERP\"]\n{{ $json.serviciosDuplicados.unique() }}\n// Output: [\"CRM\", \"WhatsApp\", \"ERP\"]",
        "datatype": "Array"
    },
    {
        "name": "isEmpty()",
        "description": "Verifica si el objeto no contiene ningún par clave-valor",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.objetoVacio: {}\n{{ $json.objetoVacio.isEmpty() }}\n// Output: true",
        "datatype": "Object"
    },
    {
        "name": "merge(object*)",
        "description": "Fusiona dos objetos en uno solo usando el primero como objeto base. Si una clave existe en ambos objetos, la clave del objeto base tiene prioridad",
        "parameters": [
            {
                "description": "El objeto que se va a fusionar con el objeto base.",
                "type": "Object",
                "required": true,
                "name": "object"
            }
        ],
        "return_type": "Object",
        "example": "// $json.data.empresa: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\"}\n// $json.data.datosAdicionales: {\"sector\": \"Transporte\", \"pais\": \"España\"}\n{{ $json.empresa.merge($json.datosAdicionales) }}\n// Output: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\", \"pais\": \"España\"}",
        "datatype": "Object"
    },
    {
        "name": "hasField(fieldName*)",
        "description": "Verifica si el objeto contiene un campo específico. Solo admite claves de nivel superior",
        "parameters": [
            {
                "description": "El campo que se va a buscar.",
                "type": "String",
                "required": true,
                "name": "fieldName"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.empresa: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\", \"ciudad\": \"Valencia\"}\n{{ $json.empresa.hasField('nombre') }}\n// Output: true",
        "datatype": "Object"
    },
    {
        "name": "removeField(key*)",
        "description": "Elimina un campo específico del objeto",
        "parameters": [
            {
                "description": "La clave del campo que se va a eliminar.",
                "type": "String",
                "required": true,
                "name": "key"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.empresa: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\", \"ciudad\": \"Valencia\"}\n{{ $json.empresa.removeField('ciudad') }}\n// Output: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\"}",
        "datatype": "Object"
    },
    {
        "name": "removeFieldsContaining(value*)",
        "description": "Elimina del objeto todos los campos que contengan un valor específico",
        "parameters": [
            {
                "description": "El valor del campo que se va a eliminar.",
                "type": "String",
                "required": true,
                "name": "value"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.empresa: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\", \"ciudad\": \"Valencia\"}\n{{ $json.empresa.removeFieldsContaining('Valencia') }}\n// Output: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\"}",
        "datatype": "Object"
    },
    {
        "name": "keepFieldsContaining(value*)",
        "description": "Elimina del objeto todos los campos que no coincidan con el valor especificado",
        "parameters": [
            {
                "description": "El valor del campo que se va a mantener.",
                "type": "String",
                "required": true,
                "name": "value"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.empresa: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\", \"ciudad\": \"Valencia\"}\n{{ $json.empresa.keepFieldsContaining('Logística') }}\n// Output: {\"sector\": \"Logística\"}",
        "datatype": "Object"
    },
    {
        "name": "compact()",
        "description": "Elimina todos los valores vacíos o nulos del objeto",
        "parameters": [],
        "return_type": "Object",
        "example": "// $json.data.datosIncompletos: {\"nombre\": \"Daniel\", \"apellido\": null, \"email\": \"\", \"telefono\": \"123456789\"}\n{{ $json.datosIncompletos.compact() }}\n// Output: {\"nombre\": \"Daniel\", \"telefono\": \"123456789\"}",
        "datatype": "Object"
    },
    {
        "name": "toJsonString()",
        "description": "Convierte el objeto en una cadena de texto JSON. Equivale a JSON.stringify",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.empresa: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\"}\n{{ $json.empresa.toJsonString() }}\n// Output: \"{\\\"nombre\\\":\\\"Translogística Maral S.L.\\\",\\\"sector\\\":\\\"Logística\\\"}\"",
        "datatype": "Object"
    },
    {
        "name": "urlEncode()",
        "description": "Transforma el objeto en una lista de parámetros URL. Solo admite claves de nivel superior",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.empresa: {\"nombre\": \"Translogística Maral S.L.\", \"sector\": \"Logística\", \"empleados\": 35}\n{{ $json.empresa.urlEncode() }}\n// Output: \"nombre=Translog%C3%ADstica%20Maral%20S.L.&sector=Log%C3%ADstica&empleados=35\"",
        "datatype": "Object"
    },
    {
        "name": "base64Encode()",
        "description": "Codifica una cadena de texto en formato base64",
        "parameters": [],
        "return_type": "Abase64encodedstring",
        "example": "// $json.data.email: \"daniel.ruiz@translogisticamaral.es\"\n{{ $json.email.base64Encode() }}\n// Output: \"ZGFuaWVsLnJ1aXpAdHJhbnNsb2dpc3RpY2FtYXJhbC5lcw==\"",
        "datatype": "String"
    },
    {
        "name": "base64Decode()",
        "description": "Decodifica una cadena codificada en base64 y la convierte en texto normal",
        "parameters": [],
        "return_type": "Aplainstring",
        "example": "// $json.data.emailCodificado: \"ZGFuaWVsLnJ1aXpAdHJhbnNsb2dpc3RpY2FtYXJhbC5lcw==\"\n{{ $json.emailCodificado.base64Decode() }}\n// Output: \"daniel.ruiz@translogisticamaral.es\"",
        "datatype": "String"
    },
    {
        "name": "extractDomain()",
        "description": "Extrae el dominio de una cadena que contiene una URL válida. Devuelve undefined si no encuentra ninguno",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.email: \"daniel.ruiz@translogisticamaral.es\"\n{{ $json.email.extractDomain() }}\n// Output: \"translogisticamaral.es\"",
        "datatype": "String"
    },
    {
        "name": "extractEmail()",
        "description": "Extrae una dirección de correo electrónico de una cadena de texto. Devuelve undefined si no encuentra ninguna",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.textoContacto: \"Contacta con Daniel Ruiz en daniel.ruiz@translogisticamaral.es para más información\"\n{{ $json.textoContacto.extractEmail() }}\n// Output: \"daniel.ruiz@translogisticamaral.es\"",
        "datatype": "String"
    },
    {
        "name": "extractUrl()",
        "description": "Extrae una URL de una cadena de texto. Devuelve undefined si no encuentra ninguna",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.textoWeb: \"Visita nuestro sitio web en https://www.translogisticamaral.es para más detalles\"\n{{ $json.textoWeb.extractUrl() }}\n// Output: \"https://www.translogisticamaral.es\"",
        "datatype": "String"
    },
    {
        "name": "extractUrlPath()",
        "description": "Extrae la ruta de una URL excluyendo el dominio raíz. Por ejemplo, \"https://example.com/orders/1/details\".extractUrlPath() devuelve \"/orders/1/details/\"",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.urlCompleta: \"https://www.translogisticamaral.es/servicios/automatizacion\"\n{{ $json.urlCompleta.extractUrlPath() }}\n// Output: \"/servicios/automatizacion\"",
        "datatype": "String"
    },
    {
        "name": "hash(algo?)",
        "description": "Devuelve la cadena de texto cifrada usando el algoritmo de hash especificado",
        "parameters": [
            {
                "description": "Qué algoritmo de hash utilizar.",
                "type": "String enum",
                "required": false,
                "name": "algo"
            }
        ],
        "return_type": "Algorithm",
        "example": "// $json.data.email: \"daniel.ruiz@translogisticamaral.es\"\n{{ $json.email.hash('md5') }}\n// Output: \"a1b2c3d4e5f6789012345678901234567\"",
        "datatype": "String"
    },
    {
        "name": "isDomain()",
        "description": "Verifica si la cadena de texto es un dominio válido",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.dominio: \"translogisticamaral.es\"\n{{ $json.dominio.isDomain() }}\n// Output: true",
        "datatype": "String"
    },
    {
        "name": "isEmail()",
        "description": "Verifica si la cadena de texto es una dirección de correo electrónico válida",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.email: \"daniel.ruiz@translogisticamaral.es\"\n{{ $json.email.isEmail() }}\n// Output: true",
        "datatype": "String"
    },
    {
        "name": "isEmpty()",
        "description": "Verifica si la cadena de texto está vacía, sin contenido",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.campoVacio: \"\"\n{{ $json.campoVacio.isEmpty() }}\n// Output: true",
        "datatype": "String"
    },
    {
        "name": "isNotEmpty()",
        "description": "Verifica si la cadena de texto contiene algún contenido",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.nombre: \"Daniel Ruiz\"\n{{ $json.nombre.isNotEmpty() }}\n// Output: true",
        "datatype": "String"
    },
    {
        "name": "isNumeric()",
        "description": "Verifica si la cadena de texto contiene únicamente dígitos numéricos",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.edadTexto: \"42\"\n{{ $json.edadTexto.isNumeric() }}\n// Output: true",
        "datatype": "String"
    },
    {
        "name": "isUrl()",
        "description": "Verifica si la cadena de texto es una URL válida",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.sitioWeb: \"https://www.translogisticamaral.es\"\n{{ $json.sitioWeb.isUrl() }}\n// Output: true",
        "datatype": "String"
    },
    {
        "name": "parseJson()",
        "description": "Analiza y convierte una cadena de texto en un objeto JSON. Equivale a JSON.parse()",
        "parameters": [],
        "return_type": "Object",
        "example": "// $json.data.jsonString: \"{\\\"nombre\\\":\\\"Daniel Ruiz\\\",\\\"edad\\\":42}\"\n{{ $json.jsonString.parseJson() }}\n// Output: {\"nombre\": \"Daniel Ruiz\", \"edad\": 42}",
        "datatype": "String"
    },
    {
        "name": "quote(mark?)",
        "description": "Envuelve la cadena de texto con comillas. Por defecto usa comillas dobles \"",
        "parameters": [
            {
                "description": "Qué estilo de comillas utilizar.",
                "type": "String",
                "required": false,
                "name": "mark"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.nombre: \"Daniel Ruiz\"\n{{ $json.nombre.quote() }}\n// Output: \"\\\"Daniel Ruiz\\\"\"",
        "datatype": "String"
    },
    {
        "name": "removeMarkdown()",
        "description": "Elimina todo el formato Markdown de la cadena de texto",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.textoMarkdown: \"**Daniel Ruiz** trabaja en *Translogística Maral*\"\n{{ $json.textoMarkdown.removeMarkdown() }}\n// Output: \"Daniel Ruiz trabaja en Translogística Maral\"",
        "datatype": "String"
    },
    {
        "name": "replaceSpecialChars()",
        "description": "Reemplaza caracteres no ASCII en la cadena con su representación ASCII equivalente",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.empresaConAcentos: \"Translogística Maral S.L.\"\n{{ $json.empresaConAcentos.replaceSpecialChars() }}\n// Output: \"Translogistica Maral S.L.\"",
        "datatype": "String"
    },
    {
        "name": "removeTags()",
        "description": "Elimina etiquetas como HTML o XML de la cadena de texto",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.textoHtml: \"<strong>Daniel Ruiz</strong> - <em>COO</em>\"\n{{ $json.textoHtml.removeTags() }}\n// Output: \"Daniel Ruiz - COO\"",
        "datatype": "String"
    },
    {
        "name": "toBoolean()",
        "description": "Convierte una cadena de texto a un valor booleano. \"false\", \"0\", \"\" y \"no\" se convierten a false",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.clienteTexto: \"false\"\n{{ $json.clienteTexto.toBoolean() }}\n// Output: false",
        "datatype": "String"
    },
    {
        "name": "toDateTime()",
        "description": "Convierte una cadena de texto en un objeto de fecha Luxon",
        "parameters": [],
        "return_type": "Date",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime() }}\n// Output: DateTime object",
        "datatype": "String"
    },
    {
        "name": "toDecimalNumber()",
        "description": "Ver toFloat",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.presupuestoTexto: \"1800.50\"\n{{ $json.presupuestoTexto.toDecimalNumber() }}\n// Output: 1800.5",
        "datatype": "String"
    },
    {
        "name": "toFloat()",
        "description": "Convierte una cadena de texto en un número decimal",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.presupuestoTexto: \"1800.50\"\n{{ $json.presupuestoTexto.toFloat() }}\n// Output: 1800.5",
        "datatype": "String"
    },
    {
        "name": "toInt()",
        "description": "Convierte una cadena de texto en un número entero",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.edadTexto: \"42\"\n{{ $json.edadTexto.toInt() }}\n// Output: 42",
        "datatype": "String"
    },
    {
        "name": "toSentenceCase()",
        "description": "Formatea la cadena de texto aplicando formato de oración (primera letra mayúscula)",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.nombre: \"daniel ruiz\"\n{{ $json.nombre.toSentenceCase() }}\n// Output: \"Daniel ruiz\"",
        "datatype": "String"
    },
    {
        "name": "toSnakeCase()",
        "description": "Formatea la cadena de texto aplicando el formato snake_case",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.empresaNombre: \"Translogística Maral S.L.\"\n{{ $json.empresaNombre.toSnakeCase() }}\n// Output: \"translogistica_maral_s_l\"",
        "datatype": "String"
    },
    {
        "name": "toTitleCase()",
        "description": "Formatea la cadena de texto aplicando formato de título. No cambia las letras ya en mayúscula para preservar información de acrónimos y marcas comerciales como iPhone o FAANG",
        "parameters": [],
        "return_type": "String",
        "example": "// $json.data.sector: \"logística y transporte\"\n{{ $json.sector.toTitleCase() }}\n// Output: \"Logística Y Transporte\"",
        "datatype": "String"
    },
    {
        "name": "toWholeNumber()",
        "description": "Convierte una cadena de texto en un número entero",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.presupuestoTexto: \"1800.75\"\n{{ $json.presupuestoTexto.toWholeNumber() }}\n// Output: 1801",
        "datatype": "String"
    },
    {
        "name": "urlDecode(entireString?)",
        "description": "Decodifica una cadena codificada para URL. Decodifica cualquier carácter codificado en porcentaje en la cadena de entrada y los reemplaza con sus caracteres originales",
        "parameters": [
            {
                "description": "Si decodificar caracteres que forman parte de la sintaxis URI (true) o no (false).",
                "type": "Boolean",
                "required": false,
                "name": "entireString"
            }
        ],
        "return_type": "Boolean",
        "example": "// $json.data.urlCodificada: \"daniel.ruiz%40translogisticamaral.es\"\n{{ $json.urlCodificada.urlDecode() }}\n// Output: \"daniel.ruiz@translogisticamaral.es\"",
        "datatype": "String"
    },
    {
        "name": "urlEncode(entireString?)",
        "description": "Codifica una cadena de texto para ser utilizada/incluida en una URL",
        "parameters": [
            {
                "description": "Si codificar caracteres que forman parte de la sintaxis URI (true) o no (false).",
                "type": "Boolean",
                "required": false,
                "name": "entireString"
            }
        ],
        "return_type": "Boolean",
        "example": "// $json.data.email: \"daniel.ruiz@translogisticamaral.es\"\n{{ $json.email.urlEncode() }}\n// Output: \"daniel.ruiz%40translogisticamaral.es\"",
        "datatype": "String"
    },
    {
        "name": "ceil()",
        "description": "Redondea un número hacia arriba al entero más cercano",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.presupuestoDecimal: 1800.25\n{{ $json.presupuestoDecimal.ceil() }}\n// Output: 1801",
        "datatype": "Number"
    },
    {
        "name": "floor()",
        "description": "Redondea un número hacia abajo al entero más cercano",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.presupuestoDecimal: 1800.75\n{{ $json.presupuestoDecimal.floor() }}\n// Output: 1800",
        "datatype": "Number"
    },
    {
        "name": "format(locales?,options?)",
        "description": "Wrapper para Intl.NumberFormat(). Devuelve una cadena formateada de un número basada en el código de idioma y opciones de formato especificados. Sin argumentos, transforma el número en formato tipo 1.234",
        "parameters": [
            {
                "description": "Una etiqueta de idioma IETF BCP 47.",
                "type": "String",
                "required": false,
                "name": "locales"
            },
            {
                "description": "Configurar opciones para el formato de números. Consulta MDN | Intl.NumberFormat() para más información.",
                "type": "Object",
                "required": false,
                "name": "options"
            }
        ],
        "return_type": "LanguageCodeoptions",
        "example": "// $json.data.presupuestoEstimado: 1800\n{{ $json.presupuestoEstimado.format('es-ES', {style: 'currency', currency: 'EUR'}) }}\n// Output: \"1.800,00 €\"",
        "datatype": "Number"
    },
    {
        "name": "isEven()",
        "description": "Devuelve true si el número es par. Solo funciona con números enteros",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.edad: 42\n{{ $json.edad.isEven() }}\n// Output: true",
        "datatype": "Number"
    },
    {
        "name": "isOdd()",
        "description": "Devuelve true si el número es impar. Solo funciona con números enteros",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.empresa.empleados: 35\n{{ $json.empresa.empleados.isOdd() }}\n// Output: true",
        "datatype": "Number"
    },
    {
        "name": "round(decimalPlaces?)",
        "description": "Devuelve el valor de un número redondeado al entero más cercano, a menos que se especifique un número de decimales",
        "parameters": [
            {
                "description": "A cuántos decimales redondear.",
                "type": "Number",
                "required": false,
                "name": "decimalPlaces"
            }
        ],
        "return_type": "Number",
        "example": "// $json.data.presupuestoDecimal: 1800.456\n{{ $json.presupuestoDecimal.round(2) }}\n// Output: 1800.46",
        "datatype": "Number"
    },
    {
        "name": "toBoolean()",
        "description": "Convierte un número a un valor booleano. 0 se convierte a false. Todos los demás valores se convierten a true",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.presupuestoEstimado: 1800\n{{ $json.presupuestoEstimado.toBoolean() }}\n// Output: true",
        "datatype": "Number"
    },
    {
        "name": "toDateTime(format?)",
        "description": "Convierte un número en un objeto de fecha Luxon",
        "parameters": [
            {
                "description": "Puede ser ms (milisegundos), s (segundos), o excel (Excel 1900). Por defecto milisegundos.",
                "type": "String enum",
                "required": false,
                "name": "format"
            }
        ],
        "return_type": "String",
        "example": "// $json.data.timestamp: 1715869520000\n{{ $json.timestamp.toDateTime('ms') }}\n// Output: DateTime object",
        "datatype": "Number"
    },
    {
        "name": "beginningOf(unit?)",
        "description": "Transforma una fecha al inicio del período de tiempo especificado. Devuelve un Date de JavaScript o Luxon Date, dependiendo de la entrada",
        "parameters": [
            {
                "description": "Una cadena válida que especifica la unidad de tiempo.",
                "type": "String enum",
                "required": false,
                "name": "unit"
            }
        ],
        "return_type": "DurationUnit",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().beginningOf('day') }}\n// Output: 2025-05-16T00:00:00Z",
        "datatype": "Date"
    },
    {
        "name": "endOfMonth()",
        "description": "Transforma una fecha al último día del mes",
        "parameters": [],
        "return_type": "Date",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().endOfMonth() }}\n// Output: 2025-05-31T23:59:59Z",
        "datatype": "Date"
    },
    {
        "name": "extract(datePart?)",
        "description": "Extrae la parte específica definida en datePart de una fecha. Devuelve un Date de JavaScript o Luxon Date, dependiendo de la entrada",
        "parameters": [
            {
                "description": "Una cadena válida que especifica la unidad de tiempo.",
                "type": "String enum",
                "required": false,
                "name": "datePart"
            }
        ],
        "return_type": "DurationUnit",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().extract('month') }}\n// Output: 5",
        "datatype": "Date"
    },
    {
        "name": "format(fmt*)",
        "description": "Da formato a una fecha según la estructura especificada",
        "parameters": [
            {
                "description": "Una cadena válida que especifica el formato de tiempo. Consulta Luxon | Table of tokens para formatos.",
                "type": "String enum",
                "required": true,
                "name": "fmt"
            }
        ],
        "return_type": "TimeFormat",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().format('dd/MM/yyyy') }}\n// Output: \"16/05/2025\"",
        "datatype": "Date"
    },
    {
        "name": "isBetween(date1*,date2*)",
        "description": "Verifica si una fecha está comprendida entre dos fechas específicas",
        "parameters": [
            {
                "description": "La primera fecha del rango.",
                "type": "Date or DateTime",
                "required": true,
                "name": "date1"
            },
            {
                "description": "La última fecha del rango.",
                "type": "Date or DateTime",
                "required": true,
                "name": "date2"
            }
        ],
        "return_type": "DateDateTimedate2",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n// $json.data.fechaInicio: \"2025-05-01\", $json.data.fechaFin: \"2025-05-31\"\n{{ $json.fechaRegistro.toDateTime().isBetween($json.fechaInicio, $json.fechaFin) }}\n// Output: true",
        "datatype": "Date"
    },
    {
        "name": "isDst()",
        "description": "Verifica si una fecha está dentro del horario de verano",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().isDst() }}\n// Output: true (depende de la zona horaria)",
        "datatype": "Date"
    },
    {
        "name": "isInLast(n?,unit?)",
        "description": "Verifica si una fecha está dentro de un período de tiempo específico",
        "parameters": [
            {
                "description": "El número de unidades. Por ejemplo, para verificar si la fecha está en las últimas nueve semanas, introduce 9.",
                "type": "Number",
                "required": false,
                "name": "n"
            },
            {
                "description": "Una cadena válida que especifica la unidad de tiempo.",
                "type": "String enum",
                "required": false,
                "name": "unit"
            }
        ],
        "return_type": "Numberunit",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().isInLast(30, 'days') }}\n// Output: true (si estamos dentro de los últimos 30 días)",
        "datatype": "Date"
    },
    {
        "name": "isWeekend()",
        "description": "Verifica si la fecha corresponde a un sábado o domingo",
        "parameters": [],
        "return_type": "Boolean",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().isWeekend() }}\n// Output: false (16 mayo 2025 es viernes)",
        "datatype": "Date"
    },
    {
        "name": "minus(n*,unit?)",
        "description": "Resta un período de tiempo específico a una fecha. Devuelve un Date de JavaScript o Luxon Date, dependiendo de la entrada",
        "parameters": [
            {
                "description": "El número de unidades. Por ejemplo, para restar nueve segundos, introduce 9 aquí.",
                "type": "Number",
                "required": true,
                "name": "n"
            },
            {
                "description": "Una cadena válida que especifica la unidad de tiempo.",
                "type": "String enum",
                "required": false,
                "name": "unit"
            }
        ],
        "return_type": "Numberunit",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().minus(7, 'days') }}\n// Output: 2025-05-09T14:45:20Z",
        "datatype": "Date"
    },
    {
        "name": "plus(n*,unit?)",
        "description": "Suma un período de tiempo específico a una fecha. Devuelve un Date de JavaScript o Luxon Date, dependiendo de la entrada",
        "parameters": [
            {
                "description": "El número de unidades. Por ejemplo, para agregar nueve segundos, introduce 9 aquí.",
                "type": "Number",
                "required": true,
                "name": "n"
            },
            {
                "description": "Una cadena válida que especifica la unidad de tiempo.",
                "type": "String enum",
                "required": false,
                "name": "unit"
            }
        ],
        "return_type": "Numberunit",
        "example": "// $json.data.fechaRegistro: \"2025-05-16T14:45:20Z\"\n{{ $json.fechaRegistro.toDateTime().plus(15, 'days') }}\n// Output: 2025-05-31T14:45:20Z",
        "datatype": "Date"
    },
    {
        "name": "toDateTime()",
        "description": "Convierte una fecha de JavaScript en un objeto de fecha Luxon",
        "parameters": [],
        "return_type": "Date",
        "example": "// $json.data.fechaJs: Date object\n{{ $json.fechaJs.toDateTime() }}\n// Output: Luxon DateTime object",
        "datatype": "Date"
    },
    {
        "name": "toInt()",
        "description": "Convierte un booleano en un número. false se convierte a 0, true se convierte a 1",
        "parameters": [],
        "return_type": "Number",
        "example": "// $json.data.esCliente: false\n{{ $json.esCliente.toInt() }}\n// Output: 0",
        "datatype": "Boolean"
    }
]

export default methodData;